export default "__VITE_ASSET__B1JWKUf8__"